import { render, staticRenderFns } from "./StaffDocumentation.vue?vue&type=template&id=c8d94498&scoped=true&"
import script from "./StaffDocumentation.vue?vue&type=script&lang=js&"
export * from "./StaffDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d94498",
  null
  
)

export default component.exports